import React from "react";
import BackButton from "../../components/common/BackButton";
import RestaurantForm from "../../components/forms/RestaurantForm";
import { useFirestoreConnect, isLoaded } from "react-redux-firebase";
import { useSelector } from "react-redux";
import LoadingIndicator from "../../components/common/LoadingIndicator";

const RestaurantPage = ({ match }) => {
  const restaurant_id = match.params.id;

  useFirestoreConnect([
    {
      collection: "restaurants",
      doc: restaurant_id,
      storeAs: `restaurant-${restaurant_id}`,
    },
    {
      collection: "categories",
      storeAs: `restaurant-${restaurant_id}-categories`,
    },
  ]);

  const restaurant = useSelector(
    ({ firestore }) => firestore.data[`restaurant-${restaurant_id}`]
  );

  const categories = useSelector(
    ({ firestore }) => firestore.data[`restaurant-${restaurant_id}-categories`]
  );

  if (!isLoaded(restaurant) || !isLoaded(categories))
    return (
      <LoadingIndicator message="Cargando datos del restaurante"></LoadingIndicator>
    );

  return (
    <div className={`px-16 py-8 text-gray-900 min-h-screen`}>
      <BackButton />
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b">Administrar datos generales</p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          <RestaurantForm
            address={restaurant.address}
            startTime={restaurant.startTime}
            endTime={restaurant.endTime}
            deliveryPercentage={restaurant.deliveryPercentage}
            id={match.params.id}
            pricePerKilometer={restaurant.pricePerKilometer}
            radius={restaurant.radius}
            minOrderTotal={restaurant.minOrderTotal}
            estimatedTime={restaurant.estimatedTime}
            address={restaurant.address}
            latitude={restaurant.latitude}
            longitude={restaurant.longitude}
            available={restaurant.available}
            id={restaurant_id}
          />
        </div>
      </div>
    </div>
  );
};

export default RestaurantPage;
